import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import VeeValidate from "vee-validate";
import axios from "axios";

Vue.config.productionTip = false;

Vue.use(VeeValidate);
Vue.use(require("vue-moment"));

class AppSettings {
  backendUrl = "";
}

axios
  .get("./config.json")
  .then(response => {
    axios.defaults.baseURL = response.data.backendUrl;
    const appSettings = new AppSettings();
    appSettings.backendUrl = response.data.backendUrl;
    Vue.prototype.$appSettings = appSettings;
    Vue.prototype.url = function(path) {
      return this.$appSettings.backendUrl + path;
    };

    new Vue({
      router,
      store,
      render: h => h(App),
    }).$mount("#app");
  }) // eslint-disable-next-line no-unused-vars
  .catch(error => {
    alert("configuration error");
  });
